import React, { useContext } from 'react';
import PropTypes from 'prop-types';


const Heading = ({level, className, children}) => {
  if(typeof level !== 'number' || level < 1 || level > 6) {
    throw new Error('Heading level must be between 1 and 6');
  }

  let classNames = '';

  if (className) {
    classNames += ` ${className}`;
  }

  const Tag = `h${level}`;

  return <Tag className={classNames.trim() || null}>{children}</Tag>;
};

Heading.propTypes = {
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired, // Semantic level
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Heading;
